import React, { useEffect, useState, useRef } from "react";
import { apiHelper } from "../../lib/ApiHelper";
import "../MainBox.css";
import { AgGridReact } from "@ag-grid-community/react";
import "@ag-grid-community/styles/ag-grid.css";
import "@ag-grid-community/styles/ag-theme-quartz.css";
import "@ag-grid-community/styles/ag-theme-balham.css";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { ModuleRegistry } from "@ag-grid-community/core";
ModuleRegistry.registerModules([
    ClientSideRowModelModule
]);
import { LicenseManager } from "@ag-grid-enterprise/core";
LicenseManager.setLicenseKey("Using_this_{AG_Grid}_Enterprise_key_{AG-058820}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Penguin_Random_House_LLC}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{InventoryHub}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{InventoryHub}_need_to_be_licensed___{InventoryHub}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{4_April_2025}____[v3]_[01]_MTc0MzcyMTIwMDAwMA==a87b1efc2ee2da35884b94c846d80314");

export default function Packs(props) {
    const [rowDataTitle, setRowDataTitle] = useState([]);
    const [rowDataPack, setRowDataPack] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const gridApi = useRef(null);
    function formatNumberWithCommas(number) {
        if (isNaN(number)) {
            return '';
        }
        let str = number.toString();
        let parts = str.split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        if (parts[1] && parts[1].length === 1) {
            parts[1] += "0";
        }
        return parts.join(".");
    }

    const handleRowClicked = (event) => {
        window.open(`/overview?isbns=${event.data.isbn}`, '_blank');
    };

    const gridOptions = {
        defaultColDef: {
            resizable: true,
            sortable: true,
            filter: false,
        },
        animateRows: true,
        accentedSort: true,
        suppressDragLeaveHidesColumns: true, // ✅ stops column from being dragged away (out of the grid)
        suppressColumnMoveAnimation: false,  // optional: shows animation when interchanging
        suppressRowClickSelection: true,
        domLayout: 'autoHeight',
    };
    const onGridReady = async (params) => {
        gridApi.current = params.api;
    };
    const clearFilters = () => {
        gridApi.current.setFilterModel(null);
        gridApi.current.onFilterChanged();
    }
    const columnDefsTitle = [
        {
            headerName: "ISBN", field: "isbn", headerClass: "HeaderClassSource",
            cellClass: "CellClassSource cursor-pointer link-isbn cell-text-left", cellRenderer: (params) => {
                return <span >{params.value}</span>;
            }, width: 100
        },
        {
            headerName: "Title", field: "title", headerClass: "HeaderClassSource",
            cellClass: "CellClassSource cell-text-left", width: 200
        },
        {
            headerName: "OSD", field: "onsaleDate", headerClass: "HeaderClassSource header-text-right",
            cellClass: "CellClassSource cell-text-right", cellRenderer: (params) => {
                if ((params.value == '0001-01-01T00:00:00')) { return <span></span>; }
                return <span>{showFormatDate(params.value)}</span>;
            }, width: 80
        },
        {
            headerName: "Fmt", field: "format", headerClass: "HeaderClassSource",
            cellClass: "CellClassSource cell-text-left", width: 80, filter: "agSetColumnFilter"
        },
        {
            headerName: "SS", field: "salesStatus", headerClass: "HeaderClassSource",
            cellClass: "CellClassSource cell-text-left", width: 70, filter: "agSetColumnFilter"
        },
        {
            headerName: "Div", field: "publisherDivision", headerClass: "HeaderClassSource",
            cellClass: "CellClassSource cell-text-left", width: 40
        },
        {
            headerName: "Imprint Name", field: "imprint", headerClass: "HeaderClassSource",
            cellClass: "CellClassSource cell-text-left", width: 120
        },
        {
            headerName: "Title Block", field: "titleBlock", headerClass: "HeaderClassSource",
            cellClass: "CellClassSource cell-text-left", width: 80
        },
        {
            headerName: "Active Batch", field: "activeBatch", headerClass: "HeaderClassSource",
            cellClass: "CellClassSource cell-text-left", width: 100
        },
        {
            headerName: "Gross Inv", field: "grossInventory", headerClass: "HeaderClassSource header-text-right",
            cellClass: "CellClassSource cell-text-right", cellRenderer: (params) => {
                return <span>{formatNumberWithCommas(params.value)}</span>;
            }, width: 80
        },
        {
            headerName: "Net Bulk Inv", field: "netInventory", headerClass: "HeaderClassSource header-text-right",
            cellClass: "CellClassSource cell-text-right", cellRenderer: (params) => {
                return <span>{formatNumberWithCommas(params.value)}</span>;
            }, width: 80
        },
        {
            headerName: "Ttl WIP", field: "totalWIP", headerClass: "HeaderClassSource header-text-right",
            cellClass: "CellClassSource cell-text-right", cellRenderer: (params) => {
                return <span>{formatNumberWithCommas(params.value)}</span>;
            }, width: 80
        },
    ];
    const columnDefsPackC = [
        {
            headerName: "Box Set ISBN", field: "boxSetISBN", headerClass: "HeaderClassSource",
            cellClass: "CellClassSource cell-text-left", width: 100
        },
        {
            headerName: "ISBN", field: "isbn", headerClass: "HeaderClassSource",
            cellClass: "CellClassSource cursor-pointer link-isbn cell-text-left", cellRenderer: (params) => {
                return <span >{params.value}</span>;
            }, width: 100
        },
        {
            headerName: "Title", field: "title", headerClass: "HeaderClassSource",
            cellClass: "CellClassSource cell-text-left", width: 200
        },
        {
            headerName: "OSD", field: "onsaleDate", headerClass: "HeaderClassSource header-text-right",
            cellClass: "CellClassSource cell-text-right", cellRenderer: (params) => {
                if ((params.value == '0001-01-01T00:00:00')) { return <span></span>; }
                return <span>{showFormatDate(params.value)}</span>;
            }, width: 80
        },
        {
            headerName: "Fmt", field: "format", headerClass: "HeaderClassSource",
            cellClass: "CellClassSource cell-text-left", width: 50
        },
        {
            headerName: "SS", field: "salesStatus", headerClass: "HeaderClassSource",
            cellClass: "CellClassSource cell-text-left", width: 50
        },
        {
            headerName: "Div", field: "publisherDivision", headerClass: "HeaderClassSource",
            cellClass: "CellClassSource cell-text-left", width: 50
        },
        {
            headerName: "Imprint Name", field: "imprint", headerClass: "HeaderClassSource",
            cellClass: "CellClassSource cell-text-left", width: 120
        },
        {
            headerName: "Title Block", field: "titleBlock", headerClass: "HeaderClassSource",
            cellClass: "CellClassSource cell-text-left", width: 80
        },
        {
            headerName: "Active Batch", field: "activeBatch", headerClass: "HeaderClassSource",
            cellClass: "CellClassSource cell-text-left", width: 100
        },
        {
            headerName: "Units in Set", field: "sets", headerClass: "HeaderClassSource header-text-right",
            cellClass: "CellClassSource cell-text-right", width: 80
        },
        {
            headerName: "Gross Inv", field: "grossInventory", headerClass: "HeaderClassSource header-text-right",
            cellClass: "CellClassSource cell-text-right", cellRenderer: (params) => {
                return <span>{formatNumberWithCommas(params.value)}</span>;
            }, width: 90
        },
        {
            headerName: "Net Bulk Inv", field: "bulkNetInv", headerClass: "HeaderClassSource header-text-right",
            cellClass: "CellClassSource cell-text-right", cellRenderer: (params) => {
                return <span>{formatNumberWithCommas(params.value)}</span>;
            }, width: 90
        },
        {
            headerName: "Ttl WIP", field: "totalWIP", headerClass: "HeaderClassSource header-text-right",
            cellClass: "CellClassSource cell-text-right", cellRenderer: (params) => {
                return <span>{formatNumberWithCommas(params.value)}</span>;
            }, width: 80
        },
    ];

    const columnDefsPackP = [
        {
            headerName: "ISBN", field: "isbn", headerClass: "HeaderClassSource",
            cellClass: "CellClassSource link-isbn cursor-pointer cell-text-left", cellRenderer: (params) => {
                return <span >{params.value}</span>;
            }, width: 100
        },
        {
            headerName: "Title", field: "title", headerClass: "HeaderClassSource",
            cellClass: "CellClassSource cell-text-left", width: 200
        },
        {
            headerName: "OSD", field: "onsaleDate", headerClass: "HeaderClassSource header-text-right",
            cellClass: "CellClassSource cell-text-right", cellRenderer: (params) => {
                if ((params.value == '0001-01-01T00:00:00')) { return <span></span>; }
                return <span>{showFormatDate(params.value)}</span>;
            }, width: 80
        },
        {
            headerName: "Fmt", field: "format", headerClass: "HeaderClassSource",
            cellClass: "CellClassSource cell-text-left", width: 50
        },
        {
            headerName: "SS", field: "salesStatus", headerClass: "HeaderClassSource",
            cellClass: "CellClassSource cell-text-left", width: 50
        },
        {
            headerName: "Div", field: "publisherDivision", headerClass: "HeaderClassSource",
            cellClass: "CellClassSource cell-text-left", width: 50
        },
        {
            headerName: "Imprint Name", field: "imprint", headerClass: "HeaderClassSource",
            cellClass: "CellClassSource cell-text-left", width: 120
        },
        {
            headerName: "Title Block", field: "titleBlock", headerClass: "HeaderClassSource",
            cellClass: "CellClassSource cell-text-left", width: 80
        },
        {
            headerName: "Active Batch", field: "activeBatch", headerClass: "HeaderClassSource",
            cellClass: "CellClassSource cell-text-left", width: 100
        },
        {
            headerName: "Units in Set", field: "sets", headerClass: "HeaderClassSource header-text-right",
            cellClass: "CellClassSource cell-text-right", width: 80
        },
        {
            headerName: "# of Box Sets", field: "boxSets", headerClass: "HeaderClassSource header-text-right",
            cellClass: "CellClassSource cell-text-right", width: 80
        },
        {
            headerName: "Gross Inv", field: "grossInventory", headerClass: "HeaderClassSource header-text-right",
            cellClass: "CellClassSource cell-text-right", cellRenderer: (params) => {
                return <span>{formatNumberWithCommas(params.value)}</span>;
            }, width: 90
        },
        {
            headerName: "Net Bulk Inv", field: "bulkNetInv", headerClass: "HeaderClassSource header-text-right",
            cellClass: "CellClassSource cell-text-right", cellRenderer: (params) => {
                return <span>{formatNumberWithCommas(params.value)}</span>;
            }, width: 90
        },
        {
            headerName: "Ttl WIP", field: "totalWIP", headerClass: "HeaderClassSource header-text-right",
            cellClass: "CellClassSource cell-text-right", cellRenderer: (params) => {
                return <span>{formatNumberWithCommas(params.value)}</span>;
            }, width: 80
        },
    ];

    const fetchData = async () => {
        try {
            setIsLoading(true);
            const packInfos = props.metaData.packInfo === 'C' ? "\\nC" : props.metaData.packInfo;
            const data = await apiHelper.inventoryPostCall("packData", { ISBN: props.metaData.isbn, packInfo: packInfos });
            if (data.titleFamily != undefined && data.titleFamily.length > 0) {
                setRowDataTitle(data.titleFamily);
            } else {
                setRowDataTitle([]);
            }
            if (data.packData != undefined && data.packData.length > 0) {
                setRowDataPack(data.packData);
            } else {
                setRowDataPack([]);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    const showFormatDate = (dateString) => {
        if (dateString) {
            const date = new Date(dateString);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const formattedDate = `${month}/${day}/${year}`;
            return formattedDate;
        }
        return null;
    };

    useEffect(() => {
        if (props.metaData) {
            fetchData();
            if (gridApi && gridApi?.current != null)
                clearFilters();
        } else {
            setRowDataTitle([]);
            setRowDataPack([]);
        }
    }, [props.metaData]);

    return (<>
        {rowDataTitle && rowDataTitle.length > 0 ? <div className="ag-theme-balham" style={{ paddingLeft: "10px", marginBottom: "10px", width: "1120px" }}>
            <p className="ml-0 mb-0 padding-top-10" style={{ fontSize:"16px" }}>Title Family</p>
            <AgGridReact
                rowData={rowDataTitle}
                columnDefs={columnDefsTitle}
                domLayout="autoHeight"
                gridOptions={gridOptions}
                onRowClicked={handleRowClicked}
                onGridReady={onGridReady}
            /> </div>
            :
            <></>}

        {rowDataPack.length > 0 ? <div className="ag-theme-balham" style={{ paddingLeft: "10px", marginTop: "30px", marginBottom: "10px" }}>
            <p className="ml-0 mb-0">Pack Data</p>
            <AgGridReact
                rowData={rowDataPack}
                columnDefs={props.metaData && props.metaData.packInfo === "C" ? columnDefsPackC : columnDefsPackP}
                domLayout="autoHeight"
                gridOptions={gridOptions}
                onRowClicked={handleRowClicked}
            /> </div>
            :
            <></>}
    </>);
}
